import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../global.css';
import bannerImage from '../images/bannerimage.png';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ margin: 0, padding: 0 }}>
      {/* Full-bleed Banner Image */}
      <img
        src={bannerImage}
        alt="Volleyball net"
        style={{
          width: '100vw',
          height: '300px',
          objectFit: 'cover',
          display: 'block'
        }}
      />

      {/* Content Section */}
      <div
        className="container"
        style={{ textAlign: 'center', paddingTop: '2rem', maxWidth: '600px', margin: '0 auto' }}
      >
        <h1 className="mb-4">Welcome to MyVolleyCoach</h1>

        <p className="mb-3">
          MyVolleyCoach is a free web-based platform designed to help volleyball coaches and players manage their teams effectively. Whether you're a coach looking to organize your team or a player wanting to track your progress, this platform has you covered.
        </p>
        <p className="mb-4">
          This website is currently under active development, and while it is free to use, it relies on community support and donations to keep running. If you find it helpful, your support is greatly appreciated! If you have any feedback or suggestions, please feel free to reach out via contact@myvolleycoach.com.
        </p>

        <button
          className="btn-primary"
          onClick={() => navigate('/')}
          style={{ marginTop: '1rem' }}
        >
          Login / Register
        </button>
      </div>
    </div>
  );
};

export default HomePage;
